import find from "lodash/find";
import isFunction from "lodash/isFunction";
import isString from "lodash/isString";
import keys from "lodash/keys";
import { NAMESPACE } from "../constants";
export default function getRequestInfo(state, scope) {
    if (isString(scope))
        return state[NAMESPACE][scope];
    if (isFunction(scope)) {
        const scopeName = find(keys(state[NAMESPACE]), scope);
        return scopeName ? state[NAMESPACE][scopeName] : undefined;
    }
    return undefined;
}
